import "./base";

// Testimonials Swiper is below the fold. Use IntersectionObserver to defer
// loading its module until the section is near the viewport. Parcel will
// code-split this into a separate chunk, keeping the initial home.js bundle
// smaller and reducing main-thread parse work on page load.
const testimonialsEl = document.querySelector('.testimonials-swiper');
if (testimonialsEl) {
  const observer = new IntersectionObserver((entries, obs) => {
    if (entries[0].isIntersecting) {
      obs.disconnect();
      import('../modules/testimonials');
    }
  }, { rootMargin: '200px' }); // 200px margin triggers fetch slightly before visible
  observer.observe(testimonialsEl);
}
